import { RestService } from './restService';
import { MeetingItem } from '../models';

export class ItemService extends RestService<MeetingItem> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }
}
